import { DocumentTypeEnum } from "@jnext/ts-axios-reward";
import { UploadFile } from "antd";
import { JFieldDTO, Output } from "../JFormCompositor";

export enum RedemptionFieldsHurlIds {
    DELIVERY_USE_PERSONAL_DATA = 'delivery.usePersonalDataAddress',
    DELIVERY_NAME = 'delivery.name',
    DELIVERY_SURNAME = 'delivery.surname',
    DELIVERY_EMAIL = 'delivery.email',
    DELIVERY_PHONE = 'delivery.phone',
    DELIVERY_ADDRESS_STREET = 'delivery.address.street',
    DELIVERY_ADDRESS_CITY = 'delivery.address.city',
    DELIVERY_ADDRESS_PROVINCE = 'delivery.address.province',
    DELIVERY_ADDRESS_POSTAL_CODE = 'delivery.address.cap',
    DELIVERY_ADDRESS_COUNTRY = 'delivery.address.country',
    DELIVERY_NOTE = 'delivery.note',
    PERSONAL_DATA_NAME = 'personalData.name',
    PERSONAL_DATA_SURNAME = 'personalData.surname',
    PERSONAL_DATA_BIRTH_PLACE = 'personalData.birth.place',
    PERSONAL_DATA_BIRTH_DATE = 'personalData.birth.date',
    PERSONAL_DATA_ADDRESS_STREET = 'personalData.address.street',
    PERSONAL_DATA_ADDRESS_CITY = 'personalData.address.city',
    PERSONAL_DATA_ADDRESS_PROVINCE = 'personalData.address.province',
    PERSONAL_DATA_ADDRESS_POSTAL_CODE = 'personalData.address.cap',
    PERSONAL_DATA_EMAIL = 'personalData.email',
    PERSONAL_DATA_PHONE = 'personalData.phone',
    PERSONAL_DATA_DOCUMENT_TYPE = 'personalData.document.type',
    PERSONAL_DATA_DOCUMENT_NUMBER = 'personalData.document.number',
    PERSONAL_DATA_DOCUMENT_FILES = 'personalData.document.files',

    APPROVAL_ACCEPT = 'approval.accept',
    APPROVAL_REJECT = 'approval.reject',
}

export type RedemptionFieldDTO = JFieldDTO<RedemptionFieldsHurlIds>

export interface RedemptionFormOutput extends Output {
    [RedemptionFieldsHurlIds.DELIVERY_EMAIL]: string,
    [RedemptionFieldsHurlIds.DELIVERY_ADDRESS_STREET]: string,
    [RedemptionFieldsHurlIds.DELIVERY_ADDRESS_POSTAL_CODE]: string,
    [RedemptionFieldsHurlIds.DELIVERY_ADDRESS_CITY]: string,
    [RedemptionFieldsHurlIds.DELIVERY_ADDRESS_PROVINCE]: string,
    [RedemptionFieldsHurlIds.DELIVERY_ADDRESS_COUNTRY]: string,
    [RedemptionFieldsHurlIds.DELIVERY_NOTE]: string,
    [RedemptionFieldsHurlIds.DELIVERY_USE_PERSONAL_DATA]: string[],
    [RedemptionFieldsHurlIds.PERSONAL_DATA_BIRTH_PLACE]: string,
    [RedemptionFieldsHurlIds.PERSONAL_DATA_BIRTH_DATE]: string,
    [RedemptionFieldsHurlIds.PERSONAL_DATA_ADDRESS_STREET]: string,
    [RedemptionFieldsHurlIds.PERSONAL_DATA_ADDRESS_POSTAL_CODE]: string,
    [RedemptionFieldsHurlIds.PERSONAL_DATA_ADDRESS_CITY]: string,
    [RedemptionFieldsHurlIds.PERSONAL_DATA_ADDRESS_PROVINCE]: string,
    [RedemptionFieldsHurlIds.PERSONAL_DATA_EMAIL]: string,
    [RedemptionFieldsHurlIds.PERSONAL_DATA_PHONE]: string,
    [RedemptionFieldsHurlIds.PERSONAL_DATA_NAME]: string,
    [RedemptionFieldsHurlIds.PERSONAL_DATA_SURNAME]: string,
    [RedemptionFieldsHurlIds.PERSONAL_DATA_DOCUMENT_TYPE]: DocumentTypeEnum,
    [RedemptionFieldsHurlIds.PERSONAL_DATA_DOCUMENT_NUMBER]: string,
    [RedemptionFieldsHurlIds.PERSONAL_DATA_DOCUMENT_FILES]: UploadFile[],
    [RedemptionFieldsHurlIds.APPROVAL_ACCEPT]: string[],
    [RedemptionFieldsHurlIds.APPROVAL_REJECT]: string[],
    [RedemptionFieldsHurlIds.DELIVERY_NAME]: string;
    [RedemptionFieldsHurlIds.DELIVERY_SURNAME]: string;
    [RedemptionFieldsHurlIds.DELIVERY_PHONE]: string;
}
export function isRedemptionFields(fields: JFieldDTO[]): fields is RedemptionFieldDTO[] {
    const keys = Object.values(RedemptionFieldsHurlIds)
    return fields.every(f => keys.includes(f.hurlId as RedemptionFieldsHurlIds))
}